import React, { useEffect, useState } from "react";
import s from "../Stock.module.css";

// Utilities
import { Currency } from "../../../../helpers/currencyConvert";
import { dateFormats } from "../../../../helpers/convertDate";

//Material Ui
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export const TableStockPrePrinted = ({
  items,
  dateType,
  filters,
  sort,
  handleSort,
  setSort,
  t,
  textColor,
  cellStyles,
}) => {
  const dates = dateFormats();

  return (
    <>
      <TableContainer className={s.tableContainer} key={1}>
        <Table className="print-table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("raffle.number")}
              >{`${t("drawNumber")} ${sort.field === "raffle.number" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("game.name")}
              >{`${t("game")} ${sort.field === "game.name" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("raffle.raffleDate")}
              >{`${t("drawDate")} ${sort.field === "raffle.raffleDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("deliveryNoteNumber")}
              >{`${t("deliveryNoteNumber")} ${sort.field === "deliveryNoteNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("raffle.price")}
              >{`${t("couponValue")} ${sort.field === "raffle.price" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("raffle.percentage")}
              >{`${t("commissionsRate")} ${sort.field === "raffle.percentage" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("nroCouponFrom")}
              >{`${t("coupons")} / ${t("from")} ${sort.field === "nroCouponFrom" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("nroCouponTo")}
              >{`${t("coupons")} / ${t("to")} ${sort.field === "nroCouponTo" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("lastDelivered")}
              >{`${t("lastDelivered")} ${sort.field === "lastDelivered" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                onClick={() => handleSort("stockAmount")}
              >{`${t("stock")} ${sort.field === "stockAmount" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map((item, i) => (
              <React.Fragment key={i}>
                <TableRow
                  sx={{ "&:hover": { backgroundColor: "secondary.light" } }}
                >
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.raffle?.number || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.game?.name || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {dates.formatDate(item?.raffle?.raffleDate) || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.deliveryNoteNumber || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {<Currency value={item?.raffle?.price} /> || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    % {item?.raffle?.percentage}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.nroCouponFrom || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.nroCouponTo || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.lastDelivered || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >{`${item.stockAmount == null ? "-" : item.stockAmount}`}</TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const TableStockInstantaneous = ({
  items,
  dateType,
  filters,
  sort,
  handleSort,
  setSort,
  t,
  textColor,
  cellStyles,
}) => {
  return (
    <>
      <TableContainer className={s.tableContainer} key={1}>
        <Table className="print-table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("raffle.serie")}
              >{`${t("serie")} ${sort.field === "raffle.serie" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("deliveryNoteNumber")}
              >{`${t("deliveryNoteNumber")} ${sort.field === "deliveryNoteNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("raffle.price")}
              >{`${t("couponValue")} ${sort.field === "raffle.price" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("raffle.percentage")}
              >{`${t("commissionsRate")} ${sort.field === "raffle.percentage" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("nroCouponFrom")}
              >{`${t("coupons")} / ${t("from")} ${sort.field === "nroCouponTo" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("nroCouponTo")}
              >{`${t("coupons")} / ${t("to")} ${sort.field === "nroCouponFrom" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("lastDelivered")}
              >{`${t("lastDelivered")} ${sort.field === "lastDelivered" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  backgroundColor: "primary.main",
                  color: textColor,
                }}
                className={s.tableTitle}
                onClick={() => handleSort("stockAmount")}
              >{`${t("stock")} ${sort.field === "stockAmount" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map((item, i) => (
              <React.Fragment key={i}>
                <TableRow
                  sx={{ "&:hover": { backgroundColor: "secondary.light" } }}
                >
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.raffle?.serie || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.deliveryNoteNumber || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {<Currency value={item?.raffle?.price} /> || "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >{`${item?.raffle?.percentage || "-"} %`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.nroCouponFrom || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.nroCouponTo || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >
                    {item?.lastDelivered || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                    }}
                  >{`${item.stockAmount == null ? "-" : item.stockAmount}`}</TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
